<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width1')">
              <el-form-item :label="$t('system.logs.oper.loginAccount') + '：'">
                <el-input v-model="listQuery.loginName" filterable clearable :placeholder="$t('system.logs.oper.loginAccount')" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width2')">
              <el-form-item :label="$t('system.logs.oper.userName') + '：'">
                <el-input v-model="listQuery.realName" filterable clearable :placeholder="$t('system.logs.oper.userName')" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width3')">
              <el-form-item :label="$t('system.logs.oper.operatingFunctions') + '：'">
                <el-input
                  v-model="listQuery.controllerName"
                  filterable
                  clearable
                  :placeholder="$t('system.logs.oper.operatingFunctions')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-show="collapse" :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width4')">
              <el-form-item :label="$t('system.logs.oper.operatingActions') +'：'">
                <el-select
                  v-model="listQuery.operatingType"
                  filterable
                  clearable
                  :placeholder="$t('system.logs.oper.operatingActions')"
                >
                  <el-option
                    v-for="(item,index) in operatingTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row
          v-show="collapse"
          style="margin-top:10px"
          :gutter="10"
          type="flex"
          justify="start"
          align="middle"
        >
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width1')">
              <el-form-item :label="$t('system.logs.oper.operationDescription')+'：'">
                <el-input
                  v-model="listQuery.operatingMessage"
                  filterable
                  clearable
                  :placeholder="$t('system.logs.oper.operationDescription')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('system.logs.oper.searchWidth.width2')">
              <el-form-item :label="$t('public.startTime')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form :label-position="'right'" :model="listQuery" :label-width="$t('system.logs.oper.searchWidth.width4')">
              <el-form-item :label="$t('system.logs.oper.clientIP')+'：'">
                <el-input v-model="listQuery.ip" filterable clearable :placeholder="$t('system.logs.oper.clientIP')" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-show="collapse" style="margin-top:10px">
          <el-col>
            <el-form
              :label-position="'right'"
              label-width="70px"
            >
              <el-form-item
                label="占位符"
                style="visibility: hidden;"
              >
                <el-input />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button @click-filter="showfilter=true">
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div  :title="item.prop==='operatingMessage' ? scope.row[item.prop]:''">
            {{ scope.row[item.prop] | switchText(item.prop) }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
// 组件
// request
import { getOperlog } from '@/api/system/log'
import { mapGetters } from 'vuex'
export default {
  name: 'operlogs',
  filters: {
    switchText(val, type) {
      if (type === 'operatingStatus') {
        return val === 0 ? vm.$t('system.logs.login.success') : vm.$t('system.logs.login.fail')
      } else if (type === 'userType') {
        return val === 0 ? vm.$t('public.usertypeList.internalUsers') : vm.$t('public.usertypeList.externalUsers')
      } else {
        return val || '/'
      }
    }
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle],
  data() {
    return {
      listQuery: {
        loginName: '',
        realName: '',
        ip: '',
        startTime: '',
        endTime: '',
        controllerName: '',
        operatingType: '',
        operatingMessage: ''
      },
      //  usertypeList: [
      //   {label: '内部用户',value: 0},
      //   {label: '外部用户 ',value: 1}
      // ],
      operatingTypeList: [
        { label: this.$t('public.others'), value: 'unknown' },
        { label: this.$t('public.create') == 'Add' ? 'Create' : this.$t('public.create') , value: 'create' },
        { label: this.$t('public.update'), value: 'update' },
        { label: this.$t('public.delete'), value: 'delete' }
      ],
      showfilter: false,
      tableList: [
        {
          value: this.$t('system.logs.oper.loginAccount'),
          prop: 'loginName',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.loginAccount'),
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.userName'),
          prop: 'realName',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.userName'),
          sortable: true,
          checked: false
        },
        {
          value: this.$t('system.logs.oper.roleName'),
          prop: 'roleName',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.roleName'),
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.operatingTime'),
          prop: 'operatingTime',
          position: 'center',
          width: 140,
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.operatingFunctions'),
          prop: 'functionName',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.operatingFunctions'),
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.operatingActions'),
          prop: 'operatingName',
          position: 'center',
          width: 150,
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.operatingResults'),
          prop: 'operatingStatus',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.operatingResults'),
          sortable: true,
          checked: true
        },
        {
          value: this.$t('system.logs.oper.clientIP'),
          prop: 'ipAddress',
          position: 'center',
          width: 150,
          sortable: true,
          checked: false
        },
        {
          value: this.$t('system.logs.oper.browserInformation'),
          prop: 'browser',
          position: 'center',
          width: this.$t('system.logs.oper.tableWidth.browserInformation'),
          sortable: true,
          checked: false
        },
        {
          value: this.$t('system.logs.oper.operationDescription'),
          prop: 'operatingMessage',
          position: 'center',
          width: 300,
          sortable: true,
          checked: true
        }
      ],

      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    ...mapGetters(['commontData'])
  },
  
  methods: {
    // 加载数据
    listLoad() {
      const startTime = new Date(this.listQuery.startTime).getTime()
      const endTime = new Date(this.listQuery.endTime).getTime()
      if (startTime > endTime) {
        this.$message.error({
          message: this.$t('public.timeError'),
          duration: 2 * 1000
        })
        return
      }
      this.listLoading = true
      getOperlog(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
        this.listLoading = false
      })
      .catch(()=>{
         this.listLoading = false
      })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
